import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import RecipeEditor from './RecipeEditor';
import { useFocusTrap } from './hooks/useFocusTrap';

export default function RecipeEditorModal({ onClose, initialData, onSave }) {
  const isEditing = !!initialData;
  const modalRef  = useRef(null);

  useFocusTrap(modalRef, { onEscape: onClose });

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center px-4 py-8 overflow-y-auto"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      onClick={onClose}
    >
      <motion.div
        ref={modalRef}
        initial={{ opacity: 0, scale: 0.96, y: 12 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.96, y: 12 }}
        transition={{ duration: 0.2 }}
        className="relative bg-pp-white dark:bg-zinc-900 rounded-2xl shadow-2xl w-full max-w-xl my-auto"
        style={{ border: '2px solid var(--accent-bg)' }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 pt-5 pb-4 border-b border-sage-900/15 dark:border-zinc-700">
          <h2 className="text-xl font-extrabold" style={{ color: 'var(--accent-text)' }}>
            {isEditing ? 'Edit Recipe' : 'New Recipe'}
          </h2>
          <button
            onClick={onClose}
            aria-label="Close"
            className="text-2xl font-bold leading-none text-sage-900/40 dark:text-zinc-500 hover:text-sage-900 dark:hover:text-zinc-100 transition"
          >
            ×
          </button>
        </div>

        {/* Scrollable body */}
        <div className="px-6 py-5 max-h-[75vh] overflow-y-auto">
          <RecipeEditor initialData={initialData} onSave={onSave} />
        </div>
      </motion.div>
    </div>
  );
}
